import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

import { getColorVariable } from './constants'

function IconColoredMapM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.32258 2.2L1 5.8V7L4.5 5L8.5 4L12 4L11.8387 3L7.96774 1L3.32258 2.2Z"
        fill={getColorVariable('#F38B00')}
      />
      <path
        d="M4.5 5.00001L1 7.00003L2.16129 11L5.5 9.00002L9.5 8.00002L13 8.00002L12 4L8.5 4.00003L4.5 5.00001Z"
        fill={getColorVariable('#F38B00')}
      />
      <path
        d="M9.49982 8L5.49982 9L2.16113 11L5.99984 13L10.9998 11.5L12.9998 8H9.49982Z"
        fill={getColorVariable('#F38B00')}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M 8.0275 0.4683 L 12.2734 2.662 L 13.5313 8.078 L 11.3349 11.9216 L 5.949 13.5374 L 1.7239 11.3361 L 0.4663 5.7049 L 3.0082 1.7649 L 8.0275 0.4683 Z M 1.8155 5.4582 L 4.3117 4.0318 L 8.4383 3.0001 L 10.7493 3.0001 L 7.9078 1.532 L 3.6367 2.6354 L 1.8155 5.4582 Z M 11.5576 4.0001 L 8.5615 4.0001 L 4.6881 4.9685 L 1.7069 6.672 L 2.4832 10.1481 L 5.3117 8.5318 L 9.4383 7.5001 L 12.3705 7.5001 L 11.5576 4.0001 Z M 6.0508 12.4629 L 10.6649 11.0786 L 12.1383 8.5001 H 9.5615 L 5.6881 9.4685 L 3.12 10.9359 Z"
        fill="var(--color-typo-primary)"
      />
    </svg>
  )
}
export const IconColoredMap = createIcon({
  l: IconColoredMapM,
  m: IconColoredMapM,
  s: IconColoredMapM,
  xs: IconColoredMapM,
  name: 'IconColoredMap',
})
